/* eslint-disable import/prefer-default-export */
export const BLOCKED_STATUS = 'blocked'
